import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "-FilterArea" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode("大学所在地"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "u-spOnly",
    id: "js-checkedAreaText"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "u-arrow-spOnlyBottom js-accordionArrow" })
], -1)
const _hoisted_3 = ["id", "value", "lval"]
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("dd", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsArea, (dataAr, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("input", {
            id: "area"+dataAr.value,
            type: "checkbox",
            value: dataAr.value,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
            name: "Ar",
            lval: `${dataAr.title}`
          }, null, 40, _hoisted_3),
          _createElementVNode("label", {
            for: "area"+dataAr.value
          }, _toDisplayString(dataAr.title), 9, _hoisted_4)
        ], 64))
      }), 128))
    ])
  ]))
}